import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useVersionSelectContextMenu } from '../../context';

type NewPropsType = {
  disabled?: boolean;
};

export const New: React.FC<NewPropsType> = ({ disabled }) => {
  const { t } = useTranslation();
  const { openNew } = useVersionSelectContextMenu();

  return (
    <Menu.Item
      leftSection={
        <FontAwesomeIcon color="var(--mantine-color-blue-8)" icon={faPlus} />
      }
      onClick={openNew}
      disabled={disabled}
    >
      {t('VERSION_SELECT.MENU.NEW')}
    </Menu.Item>
  );
};
